import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=3e6b41ea&scoped=true"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"
import style0 from "./CourseForm.vue?vue&type=style&index=0&id=3e6b41ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b41ea",
  null
  
)

export default component.exports